<template>
  <div
    class="d-flex-column justify-start align-start gold_boost_checkout-modal"
  >
    <div class="d-flex-row space-between flex-1">
      <p class="t-white title-h4 font-family-1 f-w-600">
        {{ propsalData?.user_username }} -
        {{ propsalData?.factions[0]?.title }} -
        {{ propsalData?.servers[0]?.title }} Gold
      </p>
      <button class="cross_button" @click="closeCheckout">
        <CrossIcon />
      </button>
    </div>

    <div
      class="d-flex-row lg-row-to-col justify-start align-start"
      style="overflow: auto; overflow-x: hidden"
    >
      <div class="d-flex-column justify-start align-start flex-7 gap-18">
        <NuxtLinkLocale
          :to="`/gold-seller/${propsalData?.user_slug}`"
          class="t-white title-h4 font-family-1 f-w-600 width-max-content"
        >
          <GoldSeller
            :avatar="propsalData?.user_avatar"
            :username="propsalData?.user_username"
            :review-percentage="propsalData?.positive_reviews"
            :total-reviews="propsalData?.total_reviews"
            :online="propsalData.user_online"
          />
        </NuxtLinkLocale>

        <div class="d-flex-row justify-start flex-wrap sm-row-to-col">
          <div
            class="gold_detail flex-3 d-flex-column justify-start align-start gap-10"
          >
            <label class="t-light regular-m font-family-2">{{
              $t("new.price")
            }}</label>
            <div class="d-flex-row justify-start">
              <CurrencyIcon />
              <GoldPrice :price="propsalData?.price" />
            </div>
          </div>
          <div
            class="gold_detail flex-3 d-flex-column justify-start align-start gap-10"
          >
            <label class="t-light regular-m font-family-2">{{
              $t("new.min_purchase")
            }}</label>
            <div class="d-flex-row justify-start">
              <CartBlueIcon />
              <label class="bold-l font-family-2 t-white">{{
                propsalData?.min_purchase
              }}</label>
            </div>
          </div>
          <div
            class="gold_detail flex-3 d-flex-column justify-start align-start gap-10"
          >
            <label class="t-light regular-m font-family-2">{{
              $t("new.in_stock")
            }}</label>
            <div class="d-flex-row justify-start">
              <CurrencyIcon />
              <label class="bold-l font-family-2 t-white">{{
                propsalData?.in_stock
              }}</label>
            </div>
          </div>
          <div
            class="gold_detail flex-3 d-flex-column justify-start align-start gap-10"
          >
            <label class="t-light regular-m font-family-2">{{
              $t("new.guranteed_delivery")
            }}</label>
            <div class="d-flex-row justify-start">
              <ShieldTimeIcon />
              <label class="bold-l font-family-2 t-white">
                {{ handleTiming(propsalData?.timing) }}{{ " " }}
                {{ propsalData?.timing >= 60 ? $t("order.card.hours"): $t("minutes") }}
              </label>
            </div>
          </div>
        </div>

        <GoldPicker
          :min-purchase="propsalData?.min_purchase"
          :in-stock="propsalData?.in_stock"
        />

        <div class="d-flex-column justify-start align-start gap-5 xl-hide">
          <label class="t-white font-family-1 title-h5 f-w-600">{{
            $t("new.description")
          }}</label>
          <p
            class="t-grey regular-l font-family-2"
            style="white-space: pre-line"
          >
            {{ propsalData?.description }}
          </p>
          <Divider :show-or="false" />
        </div>
        <!-- 
        <div class="d-flex-row justify-start flex-wrap">
          <div
            class="d-flex-column flex-4 justify-start align-start gap-5 xl-hide"
          >
            <label class="t-white font-family-1 title-h6 f-w-600">{{
              $t("calculators_common.servers")
            }}</label>
            <div class="d-flex-row justify-start flex-wrap">
              <div
                class="gold_detail_chip medium-m font-family-2 t-white"
                v-for="server in propsalData?.servers"
                :key="server"
              >
                {{ server.title }}
              </div>
            </div>
          </div>

          <div
            class="d-flex-column flex-4 justify-start align-start gap-5 xl-hide"
          >
            <label class="t-white font-family-1 title-h6 f-w-600">{{
              $t("new.factions")
            }}</label>
            <div class="d-flex-row justify-start flex-wrap">
              <div
                class="gold_detail_chip medium-m font-family-2 t-white"
                v-for="server in propsalData?.factions"
                :key="server"
              >
                {{ server.title }}
              </div>
            </div>
          </div>

          <div
            class="d-flex-column flex-4 justify-start align-start gap-5 xl-hide"
          >
            <label class="t-white font-family-1 title-h6 f-w-600">{{
              $t("new.realms")
            }}</label>
            <div class="d-flex-row justify-start flex-wrap">
              <div
                class="gold_detail_chip medium-m font-family-2 t-white"
                v-for="server in propsalData?.realms"
                :key="server"
              >
                {{ server.title }}
              </div>
            </div>
          </div>
        </div> -->

        <div class="d-flex-column justify-start align-start gap-5 xl-hide">
          <label class="t-white font-family-1 title-h5 f-w-600">{{
            $t("new.info")
          }}</label>
          <p class="t-grey regular-l font-family-2">
            {{ $t("new.info_desc_gold") }}
          </p>
        </div>

        <div class="d-flex-column justify-start xl-hide">
          <Info
            :title="$t('homepage.faq')"
            v-if="getGamePack?.faqs?.length > 0"
            :infos="getGamePack?.faqs"
            type="faq"
          />
        </div>
        <div class="d-flex-column justify-start align-start gap-18">
          <h4 class="t-white font-family-1 title-h5 f-w-600">
            {{ $t("latest_reviews") }}
            <span class="t-grey f-w-400">{{ reviews.length }}</span>
          </h4>
          <div
            class="d-flex-column justify-start xl-hide"
            v-if="reviews.length > 0"
          >
            <ReviewCard2
              v-for="revi in reviews"
              :review="revi.review"
              :username="revi?.reviewer_username"
              :avatar="revi.reviewer_avatar"
              :rating="revi.score"
              :detail="revi"
              :created_at="revi.created_at"
            />
          </div>
        </div>
      </div>

      <div
        class="d-flex-column justify-start align-start flex-3 cart_container"
      >
        <Cart style="position: sticky; top: 0px" />
        <SafeSecurePayments />
        <div
          class="d-flex-column justify-start above-xl-hide mobile_info"
          style="margin-top: 24px"
        >
          <div class="d-flex-column justify-start align-start gap-5">
            <label class="t-white font-family-1 title-h5 f-w-600">{{
              $t("new.info")
            }}</label>
            <p class="t-grey regular-l font-family-2">
              {{ $t("new.info_desc_gold") }}
            </p>
          </div>
          <Info
            :title="$t('homepage.faq')"
            v-if="getGamePack?.faqs?.length > 0"
            :infos="getGamePack?.faqs"
            type="faq"
          />
        </div>

        <div
          class="d-flex-column justify-start align-start gap-18 above-xl-hide"
        >
          <h4 class="t-white font-family-1 title-h5 f-w-600">
            {{ $t("latest_reviews") }}
            <span class="t-grey f-w-400">{{ reviews.length }}</span>
          </h4>
          <div class="d-flex-column justify-start" v-if="reviews.length > 0">
            <ReviewCard2
              v-for="revi in reviews"
              :review="revi.review"
              :username="revi?.reviewer_username"
              :avatar="revi.reviewer_avatar"
              :rating="revi.score"
              :detail="revi"
              :created_at="revi.created_at"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CrossIcon from "~/components/icons/CrossIcon.vue";
import Cart from "../checkout/Cart.vue";
import SafeSecurePayments from "../checkout/SafeSecurePayments.vue";
import GoldSeller from "~/components/common/table/GoldSeller.vue";
import CurrencyIcon from "~/components/icons/CurrencyIcon.vue";
import GoldPrice from "~/components/common/table/GoldPrice.vue";
import CartBlueIcon from "~/components/icons/CartBlueIcon.vue";
import GoldPicker from "./pickers/GoldPicker.vue";
import Info from "~/components/custom/Info.vue";
import ReviewCard2 from "~/components/cards/ReviewCard2.vue";
import Divider from "~/components/custom/Divider.vue";
import ShieldTimeIcon from "~/components/icons/ShieldTimeIcon.vue";
export default {
  data() {
    return {
      reviews: [],
    };
  },
  props: {
    closeCheckout: {
      default: () => {},
    },
    propsalData: {
      default: {},
    },
  },
  components: {
    CrossIcon,
    Cart,
    SafeSecurePayments,
    GoldSeller,
    CurrencyIcon,
    GoldPrice,
    CartBlueIcon,
    GoldPicker,
    Info,
    ReviewCard2,
    Divider,
    ShieldTimeIcon,
  },
  beforeMount() {
    this.getBoosterReviews();
    this.checkoutStore.setDetails({
      numberOfGold: this.minPurchase,
      price: this.propsalData?.price,
      proposalCode: this.propsalData?.proposal_code,
      inStock: this.propsalData?.in_stock,
    });
    this.checkoutStore.setPlatform({
      platform: 1,
    });
  },
  beforeUnmount() {
    this.checkoutStore.setDetails({
      numberOfGold: this.minPurchase,
    });
  },
  methods: {
    async getBoosterReviews() {
      try {
        const userSlug = this.propsalData.user_slug;
        if (!userSlug) return;
        const response = await useApiPost(
          `/api/get-single-booster/${userSlug}`,
          {
            method: "post",

            body: {
              locale: getLocale(),
              params: ["reviews"],
              reviews_count: 1,
            },
          }
        );
        if (response.data?.reviews) {
          this.reviews = response.data?.reviews;
        }
      } catch (error) {}
    },
    handleTiming(timing) {
      if (!timing) return;
      if (timing < 60) {
        return timing;
      }
      return parseFloat((timing ?? 0) / 60).toFixed(1);
    },
  },

  setup() {
    const { getGamePack } = useGameStore();
    const checkoutStore = useCheckoutStore();
    return {
      getGamePack,
      checkoutStore,
    };
  },
};
</script>
